/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useEffect } from '../../_snowpack/pkg/react.js';
import { useQuery, useMutation } from '../../_snowpack/pkg/@apollo/react-hooks.js'; // @ts-ignore

import { growl } from '../../_snowpack/pkg/@crystallize/react-growl.js';
import isEmpty from '../../_snowpack/pkg/lodash/isEmpty.js';
import isEqual from '../../_snowpack/pkg/lodash/isEqual.js';
import config from '../app-config.js';
import { GET_ME_AND_TENANTS } from '../queries/index.js';
import { SET_DEFAULT_LANGUAGE } from '../mutations/index.js';
// @ts-ignore
import { hide } from '../booting.js';
import useLocalStorage from './useLocalStorage.js';
const FALLBACK_LANGUAGE = 'en';
const defaultUserContext = {
  defaultLanguage: FALLBACK_LANGUAGE,
  language: FALLBACK_LANGUAGE,
  appPlugins: [],
  tenant: null,
  tenants: null,
  user: null
}; // @ts-ignore

export const UserContext = /*#__PURE__*/createContext(defaultUserContext);
UserContext.displayName = 'UserContext';

function updatedDefaultLanguage() {
  return growl({
    message: 'Awesome! Your default language was updated!',
    type: 'success'
  });
}

function errorDefaultLanguage() {
  return growl({
    message: 'Hmm! It was not possible to update the default language! :(',
    type: 'error'
  });
}

export function UserProvider({
  children
}) {
  const {
    data,
    loading,
    refetch
  } = useQuery(GET_ME_AND_TENANTS);
  const [tenant, setTenant] = useState({});
  const [defaultLanguage, setDefaultLanguage] = useState(FALLBACK_LANGUAGE);
  const [language, setLanguage] = useState(FALLBACK_LANGUAGE);
  const [lsTenant, setLSTenant] = useLocalStorage('crystallize:tenant');
  const [lsLanguage, setLSLanguage] = useLocalStorage('crystallize:language');
  const [appPlugins, setAppPlugins] = useLocalStorage('crystallize:appPlugins', []);
  const {
    tenants,
    ...user
  } = (data === null || data === void 0 ? void 0 : data.me) || {};
  const [mutateDefaultLanguage] = useMutation(SET_DEFAULT_LANGUAGE, {
    onCompleted: updatedDefaultLanguage,
    onError: errorDefaultLanguage
  }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  function saveAppPlugins(newPlugins) {
    setAppPlugins(newPlugins);
  }

  const checkLanguage = () => {
    if (loading || isEmpty(tenant)) {
      return;
    }

    if ((tenant === null || tenant === void 0 ? void 0 : tenant.id) !== (lsTenant === null || lsTenant === void 0 ? void 0 : lsTenant.id)) {
      var _tenant$defaults$lang, _tenant$defaults;

      setLanguage((_tenant$defaults$lang = tenant === null || tenant === void 0 ? void 0 : (_tenant$defaults = tenant.defaults) === null || _tenant$defaults === void 0 ? void 0 : _tenant$defaults.language) !== null && _tenant$defaults$lang !== void 0 ? _tenant$defaults$lang : FALLBACK_LANGUAGE);
    } else {
      if (!isEmpty(lsLanguage)) {
        setLanguage(lsLanguage);
      } else {
        var _tenant$defaults$lang2, _tenant$defaults2;

        setLanguage((_tenant$defaults$lang2 = tenant === null || tenant === void 0 ? void 0 : (_tenant$defaults2 = tenant.defaults) === null || _tenant$defaults2 === void 0 ? void 0 : _tenant$defaults2.language) !== null && _tenant$defaults$lang2 !== void 0 ? _tenant$defaults$lang2 : FALLBACK_LANGUAGE);
      }
    }
  };

  const checkDefaultLanguage = () => {
    var _tenant$defaults$lang3, _tenant$defaults3;

    if (loading || isEmpty(tenant)) {
      return;
    }

    const defaultTenantLanguage = (_tenant$defaults$lang3 = tenant === null || tenant === void 0 ? void 0 : (_tenant$defaults3 = tenant.defaults) === null || _tenant$defaults3 === void 0 ? void 0 : _tenant$defaults3.language) !== null && _tenant$defaults$lang3 !== void 0 ? _tenant$defaults$lang3 : FALLBACK_LANGUAGE;

    if (defaultLanguage !== defaultTenantLanguage) {
      setDefaultLanguage(defaultTenantLanguage);
    }
  };

  useEffect(() => {
    var _data$me$tenants$0$te, _data$me, _data$me$tenants, _data$me$tenants$;

    if (loading) {
      return;
    } // Cypress provides a tenant override while running


    if (config.TENANT_OVERRIDE) {
      return setTenant(config.TENANT_OVERRIDE);
    }

    const dataTenant = (_data$me$tenants$0$te = data === null || data === void 0 ? void 0 : (_data$me = data.me) === null || _data$me === void 0 ? void 0 : (_data$me$tenants = _data$me.tenants) === null || _data$me$tenants === void 0 ? void 0 : (_data$me$tenants$ = _data$me$tenants[0]) === null || _data$me$tenants$ === void 0 ? void 0 : _data$me$tenants$.tenant) !== null && _data$me$tenants$0$te !== void 0 ? _data$me$tenants$0$te : {}; // new user

    if (isEmpty(lsTenant) && isEmpty(dataTenant)) {
      return setTenant({});
    }

    if (isEmpty(lsTenant) && !isEmpty(dataTenant)) {
      setTenant(dataTenant);
      return setLSTenant(dataTenant);
    }

    if (!isEmpty(lsTenant)) {
      var _data$me2, _data$me2$tenants;

      const isTenantFromUser = data === null || data === void 0 ? void 0 : (_data$me2 = data.me) === null || _data$me2 === void 0 ? void 0 : (_data$me2$tenants = _data$me2.tenants) === null || _data$me2$tenants === void 0 ? void 0 : _data$me2$tenants.some(({
        tenant
      }) => tenant.id === lsTenant.id);

      if (isTenantFromUser) {
        return setTenant(lsTenant);
      } else {
        // TODO: it's possible that users with no tenants will end up here with and empty object
        return setTenant(dataTenant);
      }
    }
  }, [data]); // manage local storage tenant

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!tenant) {
      return;
    }

    if (!isEqual(lsTenant, tenant)) {
      setLSTenant(tenant);
    }

    const inTenants = tenants === null || tenants === void 0 ? void 0 : tenants.some(({
      tenant: t
    }) => (t === null || t === void 0 ? void 0 : t.id) === tenant.id); // update tenants list

    if (!inTenants) {
      refetch();
    }

    checkLanguage();
    checkDefaultLanguage();
  }, [tenant]); // manage local storage language

  useEffect(() => {
    if (loading) {
      return;
    }

    if (language !== lsLanguage) {
      setLSLanguage(language);
    }
  }, [language]);
  useEffect(() => {
    if (loading || isEmpty(tenant)) {
      return;
    }

    if (tenant && tenant.defaults.language !== defaultLanguage) {
      mutateDefaultLanguage({
        variables: {
          tenantId: tenant === null || tenant === void 0 ? void 0 : tenant.id,
          language: defaultLanguage
        }
      });
      setTenant({ ...tenant,
        defaults: { ...(tenant === null || tenant === void 0 ? void 0 : tenant.defaults),
          language: defaultLanguage
        }
      });
    }
  }, [defaultLanguage]); //* NOTE: empty ({}) tenant is valid, since it could be a new user

  if (loading) {
    return null;
  } // safe to remove the loading


  hide();
  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: {
      appPlugins,
      defaultLanguage,
      language,
      refetch,
      saveAppPlugins,
      setDefaultLanguage,
      setLanguage,
      setTenant,
      tenant,
      tenants,
      user: user
    }
  }, children);
}